<template>
  <div>
    <!-- User Account Control modal -->
    <b-modal
      id="UACModal"
      size="xl"
      content-class="menu-bg-blue-transparent-modal uac-modal"
      body-class="p-0"
      title="User Accounts"
      hide-footer
     
      scrollable
      @show="initUAC()"
      @hidden="resetUACReports()"
    >
      <b-container fluid class="p-0">
        <b-tabs align="center" card pills justified class="p-0">
          <!-- User Account Control tab -->
          <b-tab title="User Account Control" class="pt-0">
            <b-row class="p-2" v-if="deletedGroupFeedback" id="uacDeletedGroupFeedbackWindow">
              <b-col class="text-center">
                <span class="ml-1">
                  <b class="alert alert-danger">{{
                    this.deletedGroupFeedback
                  }}</b>
                  <fa
                    :icon="['fas', 'window-close']"
                    @click="deletedFeedbackHide()"
                  />
                </span>
              </b-col>
            </b-row>
            <b-row class="p-2 w-100 dflex justify-content-end align-items-center" no-gutters>
              <div class="user-table-actions">
                <b-button 
                  class="btn btn-info text-nowrap w-auto" 
                  variant="danger" 
                  @click="todate = null; fromdate = null"
                  v-if="todate || fromdate"
                >Clear</b-button>
                <b-form-input
                  class="form-control col-sm-3 propStyle"
                  type="date"
                  placeholder="From date"
                  format="yyyy/mm/dd"
                  @change="dateChange"
                  v-model="fromdate"
                ></b-form-input>
                <label class="pt-2">TO</label>
                <b-form-input
                  class="form-control col-sm-3 propStyle"
                  type="date"
                  placeholder="To date"
                  format="yyyy/mm/dd" 
                  @change="dateChange"
                  v-model="todate"
                ></b-form-input>
                <b-form-checkbox-group class="checkboxes" v-model="statuses" style="width: auto;">
                  <b-form-checkbox size="lg" :value="false">Inactive</b-form-checkbox>
                  <b-form-checkbox size="lg" :value="true">Active</b-form-checkbox>
                </b-form-checkbox-group>
                <b-button class="btn btn-info text-nowrap w-auto" @click="downloadCSV">Download CSV</b-button>
                <b-button class="btn btn-success text-nowrap w-auto" @click="initNewUserModal()" v-if="globalIsUserAllowed('New_User')">Add New User</b-button>
              </div>
            </b-row>
            <vue-bootstrap4-table
              ref="userTable"
              :rows="filteredUsers"
              :columns="usersColumns"
              :config="usersConfig"
              :classes="classes"
            >
              <template slot="sortable_date" slot-scope="props">
                {{ props.row.last_login_date }}
              </template>
              <template slot="update" slot-scope="props">
                <b-button
                  variant="info"
                  @click="$emit('updateUser', parseInt(props.row.id))"
                  v-if="globalIsUserAllowed('Update_User')"
                >
                  <fa :icon="['fas', 'pencil-alt']" size="lg" />
                </b-button>
              </template>
              <template slot="inactive" slot-scope="props">
                <b-button 
                  variant="transparent" 
                  @click="activateEntryHandler(props.row)"
                  v-if="props.row.inactive != null && globalIsUserAllowed('Update_User')"  
                  @mouseover="hoveredRowId = props.row.id"
                  @mouseleave="hoveredRowId = null"
                  title="Activate User"
                >
                  <fa
                    :icon="['fas', hoveredRowId === props.row.id ? 'lock-open' : 'lock']"
                    size="lg"
                    :class="hoveredRowId === props.row.id ? 'green-icon' : 'red-icon'"
                  />
                </b-button>
                <b-button
                  v-else-if="globalIsUserAllowed('Update_User')"
                  variant="transparent"
                  @click="deleteEntryHandler(props.row)" 
                  @mouseover="hoveredRowId = props.row.id"
                  @mouseleave="hoveredRowId = null"
                  title="Deactive User"
                >
                  <fa
                    :icon="['fas', hoveredRowId === props.row.id ? 'lock' : 'lock-open']"
                    size="lg"
                    :class="hoveredRowId === props.row.id ? 'red-icon' : 'green-icon'"
                  />
                </b-button>
              </template>
            </vue-bootstrap4-table>
          </b-tab>
          <!-- Permissions tab -->
          <!-- REFACTOR SUGGESTION -- WEBGIS-2618 -- Could make 3 Months, 6 Months number of days more accurate -->
          <b-tab title="Permissions">
            <b-row>
              <b-dropdown :text="this.currentTitle" class="date-range">
                <b-dropdown-item @click="changeTimePeriod(1)"
                  >Last 24 Hours</b-dropdown-item
                >
                <b-dropdown-item @click="changeTimePeriod(7)"
                  >Last Week</b-dropdown-item
                >
                <b-dropdown-item @click="changeTimePeriod(30)"
                  >Last Month</b-dropdown-item
                >
                <b-dropdown-item @click="changeTimePeriod(90)"
                  >Last 3 Months</b-dropdown-item
                >
                <b-dropdown-item @click="changeTimePeriod(180)"
                  >Last 6 Months</b-dropdown-item
                >
                <b-dropdown-item @click="changeTimePeriod(365)"
                  >Last Year</b-dropdown-item
                >
              </b-dropdown>
            </b-row>
            <vue-bootstrap4-table
              :rows="permissionsRows"
              :columns="permissionsColumns"
              :config="configNoPagination"
              :classes="classes"
            ></vue-bootstrap4-table>
            <b-row>
              <p style="margin-left: auto; margin-right: auto">
                Excludes test accounts.
              </p>
            </b-row>
          </b-tab>
          <!-- Reports tab -->
          <b-tab
            title="Reports"
            @click="recentPeriod = recentPeriod == '1' ? 1 : recentPeriod"
          >
            <b-container class="px-auto">
              <b-row class="py-3" align-v="center">
                <b-col>
                  <b-button
                    :variant="dayButtonClassCtrl"
                    class="btn mx-3 text-nowrap w-auto"
                    @click="changeTimePeriod(1)"
                  >
                    Last 24 Hours
                  </b-button>
                </b-col>
                <b-col>
                  <b-button
                    :variant="weekButtonClassCtrl"
                    class="btn mx-3 text-nowrap w-auto"
                    @click="changeTimePeriod(7)"
                  >
                    Last Week
                  </b-button>
                </b-col>
                <b-col>
                  <b-button
                    :variant="monthButtonClassCtrl"
                    class="btn mx-3 text-nowrap w-auto"
                    @click="changeTimePeriod(30)"
                  >
                    Last Month
                  </b-button>
                </b-col>
                <b-col>
                  <b-button
                    :variant="quarterButtonClassCtrl"
                    class="btn mx-3 text-nowrap w-auto"
                    @click="changeTimePeriod(90)"
                  >
                    Last 3 Months
                  </b-button>
                </b-col>
                <b-col>
                  <b-button
                    :variant="halfYearButtonClassCtrl"
                    class="btn mx-3 text-nowrap w-auto"
                    @click="changeTimePeriod(180)"
                  >
                    Last 6 Months
                  </b-button>
                </b-col>
                <b-col>
                  <b-button
                    :variant="yearButtonClassCtrl"
                    class="btn mx-3 text-nowrap w-auto"
                    @click="changeTimePeriod(365)"
                  >
                    Last Year
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
            <b-card class="menu-bg-blue-transparent">
              <b-row align-h="center" class="mt-5">
                <apexchart
                  type="donut"
                  width="650"
                  :options="loginsOptions"
                  :series="loginsSeries"
                ></apexchart>
              </b-row>
            </b-card>
          </b-tab>
          <!-- Test Accounts tab -->
          <b-tab title="Test Accounts">
            <vue-bootstrap4-table
              :rows="testAccountsRows"
              :columns="testAccountsColumns"
              :config="configNoPagination"
              :classes="classes"
            ></vue-bootstrap4-table>
            <div class="center">
              <p>
                The credentials to each test account can be found
                <a
                  href="https://ushrauto.atlassian.net/wiki/spaces/DRT/pages/2205777921/MMP+Test+Account+Credentials"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  here.
                </a>
              </p>
            </div>
          </b-tab>
          <!-- Groups tab -->
          <b-tab title="Groups">
            <b-row class="py-3" v-if="deletedGroupFeedback" id="groupsDeletedGroupFeedbackWindow">
              <b-col class="text-center">
                <span class="ml-1">
                  <b class="alert alert-danger">{{
                    this.deletedGroupFeedback
                  }}</b>
                  <fa
                    :icon="['fas', 'window-close']"
                    @click="deletedFeedbackHide()"
                  />
                </span>
              </b-col>
            </b-row>
            <b-row class="py-3" v-if="addedGroupFeedback" id="groupsAddedGroupFeedbackWindow">
              <b-col class="text-center">
                <span class="ml-1">
                  <b class="alert alert-success">{{ this.addedGroupFeedback }}</b>
                  <fa
                    :icon="['fas', 'window-close']"
                    @click="addedFeedbackHide()"
                  />
                </span>
              </b-col>
            </b-row>
            <b-row class="py-3 ml-2" v-if="globalIsUserAllowed('New_Operator_Group')">
              <b-button variant="success" @click="initNewGroupModal()">
                Create New Group
              </b-button>
            </b-row>
            <vue-bootstrap4-table
              :rows="groupsRows"
              :columns="groupsColumns"
              :config="configNoPagination"
              :classes="classes"
            >
              <template slot="group" slot-scope="props">
                <div v-if="props.row.update && globalIsUserAllowed('Update_Operator_Group')">
                  <b-form-input type="text" v-model="props.row.group" />
                  <b-button
                    class="btn btn-success pt-1"
                    @click="changeGroupName(props.row)"
                  >
                    <fa :icon="['fas', 'check']" />
                  </b-button>
                  <b-button
                    class="btn btn-danger pt-1"
                    @click="cancelChangeGroupName(props.row)"
                  >
                    <fa :icon="['fas', 'times']" />
                  </b-button>
                </div>
                <div v-else>
                  <span>{{ props.row.group }}</span>
                </div>
              </template>
              <template slot="update" slot-scope="props" v-if="globalIsUserAllowed('Update_Operator_Group')">
                <b-button
                  variant="info"
                  @click="updateGroup(props.row)"
                  :disabled="props.row.group == 'None'"
                >
                  <fa :icon="['fas', 'pencil-alt']" size="lg" />
                </b-button>
              </template>
              <template slot="delete" slot-scope="props" v-if="globalIsUserAllowed('Delete_Operator_Group')">
                <b-button
                  :disabled="props.row.group == 'None'"
                  variant="danger"
                  @click="deleteGroup(props.row)"
                >
                  <fa :icon="['fas', 'minus']" size="lg" />
                </b-button>
              </template>
            </vue-bootstrap4-table>
          </b-tab>
        </b-tabs>
      </b-container>
    </b-modal>

    <!-- Make Inactive Confirmation Modal -->
    <b-modal
      id="confirmInactiveModal"
      size="md"
      content-class="sub-menu-bg-blue-transparent"
      title="Deactivate User Confirmation"
      hide-footer
    >
      <b-container v-if="selectedUser">
        <b-row class="py-2 text-center">
          <b-col>
            User with name <span class="yellow-text">{{ this.selectedUser.name }}</span> and email <span class="yellow-text">{{ this.selectedUser.email }}</span> will be deactivated.  
          </b-col>
        </b-row>
        <b-row class="py-2 text-center">
          <b-col>
            Please confirm this action. 
          </b-col>
        </b-row>
        <b-row class="row-input py-2 w-100" no-gutters>
          <b-col class="text-center">
            <b-button
              variant="primary"
              size="lg"
              type="submit"
              @click="deleteEntry()"
            >
              Confirm and Submit
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>

    <!-- Make Active Confirmation Modal -->
    <b-modal
      id="confirmActiveModal"
      size="md"
      content-class="sub-menu-bg-blue-transparent"
      title="Activate User Confirmation"
      hide-footer
    >
      <b-container v-if="selectedUser">
        <b-row class="py-2 text-center">
          <b-col>
            User with name <span class="yellow-text">{{ this.selectedUser.name }}</span> and email <span class="yellow-text">{{ this.selectedUser.email }}</span> will be activated.  
          </b-col>
        </b-row>
        <b-row class="py-2 text-center">
          <b-col>
            Please confirm this action. 
          </b-col>
        </b-row>
        <b-row class="row-input py-2 w-100" no-gutters>
          <b-col class="text-center">
            <b-button
              variant="primary"
              size="lg"
              type="submit"
              @click="activateEntry()"
            >
              Confirm and Submit
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
  
</template>

<style>
.red-icon {
  color: red !important;
}

.red-icon:hover, .green-icon:hover {
  opacity: 0.7;
}

.green-icon {
  color: green !important;
}

#UACModal .vbt-simple-filter-clear, #UACModal .vbt-global-search-clear {
  display: none !important;
}

#UACModal .dropdown, #UACModal .dropdown a {
  min-width: 190px !important;
}

#UACModal .dropdown-menu {
  max-width: 190px !important;
  background-color: #ffffff;
  font-weight: 500;
  text-shadow: none !important;
  cursor: pointer !important;
  border: 1px solid rgba(6, 60, 109, 0.12);
}

#UACModal .dropdown-menu label {
  cursor: pointer !important;
  color: #063c6d !important;
}

#UACModal .dropdown-item {
  color: #063c6d !important;
}

#UACModal .dropdown-item:hover {
  background-color: #063c6d !important;
  color: #ffffff !important;
}

#UACModal .dropdown-item:focus {
  background-color: #063c6d !important;
  color: #ffffff !important;
}

#UACModal #multifilter_org.btn {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}

@media (max-width: 470px) {
  .xs-spacing {
    padding-top: 2rem;
  }
}
@media (min-width: 768px) {
  .modal-xl {
    width: 95%;
    max-width: 1600px;
  }
}
.yellow-text {
  color: yellow;
  font-weight: 900;
}

#confirmInactiveModal .close {
  color: white;
  text-shadow: none;
  opacity: 0.8;
}

#confirmInactiveModal .close:hover {
  opacity: 1;
}

#confirmActiveModal .close {
  color: white;
  text-shadow: none;
  opacity: 0.8;
}

#confirmActiveModal .close:hover {
  opacity: 1;
}

.info-tooltip {
  position: relative;
  display: inline-block;
}
.info-tooltip .info-tooltip-text {
  visibility: hidden;
  width: 100px;
  font-size: 15px;
  top: 5%;
  margin-left: 30px;
  background-color: #212529;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 200000;
}
.info-tooltip:hover .info-tooltip-text {
  visibility: visible;
}
.button-center {
  margin: 0 auto;
  display: block;
}
.center {
  text-align: center;
}
.date-range {
  margin-left: auto;
  margin-right: 0;
  padding-bottom: 15px;
  padding-right: 15px;
}
.apexcharts-menu {
  background: rgb(228, 9, 9) !important;
}
.apexcharts-menu-item:hover {
  background: rgb(193, 116, 116) !important;
}
.user-table-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
  gap: 10px;
}

.user-table-actions .btn {
  max-width: none !important;
}

/* ── UAC modal table + tabs ──────────────────────────────────── */
.uac-modal .menu-bg-blue-transparent,
.uac-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.uac-modal table { color: #063c6d !important; text-shadow: none !important; }
.uac-modal thead th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-shadow: none !important;
}
.uac-modal thead th a,
.uac-modal thead th svg { color: rgba(6, 60, 109, 0.5) !important; }
.uac-modal thead th input {
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
  font-size: 0.85rem;
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
}
.uac-modal tbody tr { color: #063c6d !important; text-shadow: none !important; }
.uac-modal tbody tr:hover { background: rgba(6, 60, 109, 0.04) !important; }
.uac-modal tbody td {
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.08) !important;
  text-shadow: none !important;
}
.uac-modal .footer-pagination-row td,
.uac-modal .footer-pagination-row th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  text-shadow: none !important;
}
.uac-modal .nav-pills .nav-link {
  color: rgba(6, 60, 109, 0.65);
  background: transparent;
  border: 1px solid rgba(6, 60, 109, 0.3);
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  margin: 0 4px;
  transition: background 0.15s;
}
.uac-modal .nav-pills .nav-link.active {
  background: #063c6d !important;
  color: #fff !important;
  border-color: #063c6d !important;
}
</style>

<script>
import 'vue-date-pick/dist/vueDatePick.css'
import DatePick from 'vue-date-pick'
import Multiselect from 'vue-multiselect'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import axios from 'axios'

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { mapGetters } from 'vuex';

export default {
  name: 'MMP_UserAccountControl',
  components: {
    Multiselect,
    VueBootstrap4Table,
    DatePick
  },
  // computed: {
  //   ...mapGetters(['globalUserRole', 'globalAllowedUserModules', 'globalIsUserAllowed'])
  // },
  props: ['newGroupAdded', 'user'],
  data() {
    return {
      app: 'uac',
      formSubmitErrors: [],
      usersRows: [],
      organizations: [],
      submitSuccess: '',
      updateSuccessMsg: '',
      addedGroupFeedback: '',
      deletedGroupFeedback: '',
      inactiveChk: true,
      inactiveClass: 'btn btn-primary mr-5',
      dayButtonClassCtrl: 'primary',
      monthButtonClassCtrl: 'light',
      weekButtonClassCtrl: 'light',
      quarterButtonClassCtrl: 'light',
      halfYearButtonClassCtrl: 'light',
      yearButtonClassCtrl: 'light',
      bgColorChange: {
        backgroundColor: '#ffffff'
      },
      form: {
        name: null,
        email: null,
        password: null,
        org: null,
        authorization: [],
        testAccount: 'False'
      },
      usersColumns: [
        {
          label: 'User Name',
          name: 'name',
          sort: true,
          filter: {
            type: "simple",
            placeholder: "Name"
          },
        },
        {
          label: 'Email',
          name: 'email',
          sort: true,
          filter: {
            type: "simple",
            placeholder: "Email"
          },
        },
        {
          label: 'Organization',
          name: 'org',
          sort: true,
          filter: {
            type: "select",
            placeholder: "Select Organization",
            mode: "multi",
            select_all_checkbox: {
              visibility: false
            },
            options: [] // dynamic
          }
        },
        {
          label: 'Authorization',
          name: 'authorization',
          sort: true
        },
        {
          label: 'Group',
          name: 'authgroup',
          sort: true
        },
        {
          label: 'Last Login Date',
          name: 'sortable_date',
          sort: true
        },
        {
          label: 'Update',
          name: 'update',
          sort: false
        },
        {
          label: 'Status',
          name: 'inactive',
          sort: false
        }
      ],
      permissionsColumns: [
        {
          label: 'Permission Level',
          name: 'permissions'
        },
        {
          label: 'Number of Users',
          name: 'count'
        },
        {
          label: 'Number of Users in Selected Time Period',
          name: 'users'
        }
      ],
      testAccountsColumns: [
        {
          label: 'Email',
          name: 'email'
        },
        {
          label: 'Permission',
          name: 'authorization.permissions'
        }
      ],
      groupsColumns: [
        {
          label: 'Group',
          name: 'group'
        },
        {
          label: 'Number of Users',
          name: 'count'
        },
        {
          label: 'Update',
          name: 'update',
          sort: false
        },
        {
          label: 'Delete',
          name: 'delete',
          sort: false
        }
      ],
      actions: [],
      usersConfig: {
        filter: true,
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          visibility: false
        },
        highlight_row_hover_color: 'rgba(6,60,109,0.04)',
        show_refresh_button: false,
        show_reset_button: false
      },
      config: {
        filter: true,
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          visibility: true,
          showClearButton: true
        },
        highlight_row_hover_color: 'rgba(6,60,109,0.04)',
        show_refresh_button: false,
        show_reset_button: false
      },
      configNoPagination: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          visibility: false
        },
        highlight_row_hover_color: 'rgba(6,60,109,0.04)',
        pagination: false,
        show_refresh_button: false,
        show_reset_button: false
      },
      Spinner: false,
      permissions: [
        {
          perm: {permissions: 'USHR Platform Admin'},
          name: 'USHR Platform Admin'
        },
        {
          perm: {permissions: 'USHR Acquisition Admin'},
          name: 'USHR Acquisition Admin'
        },
        {perm: {permissions: 'USHR Operator'}, name: 'USHR Operator'},
        {perm: {permissions: 'USHR User'}, name: 'USHR User'},
        {perm: {permissions: 'GM User'}, name: 'GM User'},
        {perm: {permissions: 'Nissan User'}, name: 'Nissan User'},
        {perm: {permissions: 'Rivian User'}, name: 'Rivian User'},
        {perm: {permissions: 'Generic User'}, name: 'Generic User'}
      ],
      permissionsRows: [],
      testAccountsRows: [],
      groups: [],
      groupsRows: [],
      csv: 'data:text/csv;charset=utf-8,',
      recentPeriod: '1',
      titleDay: 'Last 24 Hours',
      titleWeek: 'Last Week',
      titleMonth: 'Last Month',
      titleThreeMonths: 'Last 3 Months',
      titleSixMonths: 'Last 6 Months',
      titleYear: 'Last Year',
      updateGroupSuccess: '',
      deleteGroupSuccess: '',
      currentTitle: 'Last 24 Hours',
      loginsOptions: {
        chart: {
          id: 'loginsByPermissionLevel',
          type: 'donut',
          toolbar: {
            show: true,
            tools: {
              download: true
            },
            export: {
              csv: {
                filename: undefined,
                columnDelimiter: ',',
                headerCategory: 'Permission Level',
                headerValue: 'Number of Users',
                dateFormatter(timestamp) {
                  return new Date(timestamp).toDateString
                }
              }
            }
          }
        },
        labels: [],
        legend: {
          labels: {
            useSeriesColors: true
          }
        },
        plotOptions: {},
        dataLabels: {
          enabled: true
        }
      },
      loginsSeries: [],
      classes: {
        table: {
          'menu-bg-blue-transparent': true
        }
      },
      selectedUser: null,
      statuses: [false, true],
      filteredTableRows: [],
      hoveredRowId: null,
      fromdate: '',
      todate: ''
    }
  },
  methods: {
    dateChange() {
      let from = this.fromdate || null; 
      let to = this.todate || null;

      if (to > new Date().toISOString().split("T")[0]) {
        this.todate = new Date().toISOString().split("T")[0];
        this.$bvToast.toast('To Date should not exceed current date!', {
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true,
          title: 'Invalid Input',
          toaster: 'b-toaster-top-center'
        })
      }
      if (from > to) {
        this.$bvToast.toast('From Date should not exceed To date!', {
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true,
          title: 'Invalid Input',
          toaster: 'b-toaster-top-center'
        })
      }
      if (from > new Date().toISOString().split("T")[0]) {
        this.fromdate = new Date().toISOString().split("T")[0];
        this.$bvToast.toast('From Date should not exceed current date!', {
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true,
          title: 'Invalid Input',
          toaster: 'b-toaster-top-center'
        })
      }
    },
    downloadCSV() {
      this.filteredTableRows = this.$refs.userTable.temp_filtered_results.map(user => ({
        id: user.id,
        name: user.name,
        email: user.email,
        org: user.org,
        last_login_date: user.last_login_date
      }));

      this.csvExport(this.filteredTableRows, 'Users')
    },
    getCompanies() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/company/', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Companies API Call Error: ' + content.errors)
            } else {
              this.organizations = content.map((org) => ({
                "name": org.company_name,
                "value": org.company_name
              }))

              this.usersColumns[2].filter.options = this.organizations;
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    initUAC() {
      this.loadAuthorizationCount()
      this.loadTestAccountsRows()
      this.loadGroupCount()
      this.loadUsers()
    },
    resetUACReports() {
      this.changeTimePeriod(1)
      this.recentPeriod = '1'
      this.todate = null;
      this.fromdate = null;
    },
    flipInactiveUsers() {
      this.inactiveChk = !this.inactiveChk
      this.inactiveClass = this.inactiveChk
        ? 'btn btn-primary mr-5'
        : 'btn btn-dark mr-5'
      this.loadUsers()
    },
    activateEntryHandler(row) {
      this.selectedUser = row
      this.$bvModal.show('confirmActiveModal')
    },
    activateEntry() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/activateUser', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              userId: this.selectedUser.id
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('activateUser API Call Error: ' + content.errors)
            } else {
              this.$bvToast.toast('User successfully activated.', {
                title: 'User Status Updated',
                toaster: 'b-toaster-top-center'
              })
              this.$bvModal.hide('confirmActiveModal')
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    closeUAC() {
      this.$bvModal.hide('UACModal')
    },
    addedFeedbackHide() {
      this.addedGroupFeedback = ''
      this.$emit('resetGroupAddedFeedback')
    },
    deletedFeedbackHide() {
      this.deletedGroupFeedback = ''
    },
    loadUsers() {
      this.Spinner = true
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/users', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Users API Call Error: ' + content.errors)
            } else {
              this.usersRows = content.rows
              this.usersDateFormat()
              this.Spinner = false
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    usersDateFormat() {
      this.usersRows.forEach(user => {
        if (user.last_login_date) {
          let date = new Date(user.last_login_date)
          user.last_login_date = date.toLocaleDateString() + " , " +
                date.toLocaleTimeString(navigator.language, {
                  hour: '2-digit',
                  minute: '2-digit'
                })
          user.sortable_date = date.toISOString().split("T")[0] // e.g. "2025-07-25"
        }
      })
    },
    deleteEntryHandler(row) {
      this.selectedUser = row
      this.$bvModal.show('confirmInactiveModal')
    },
    deleteEntry() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/deleteUser/' + this.selectedUser.id, {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              id: this.selectedUser.id
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('deleteUser API Call Error: ' + content.errors)
              // Else no errors and we can load returned entry into form
            } else {
              // WEBGIS-3225 -- removing this code for now as the inactive users feature is broken. 
              // for (let i = this.usersRows.length - 1; i >= 0; i--) {
              //   if (this.usersRows[i].id === this.selectedUser.id) {
              //     this.usersRows.splice(i, 1)
              //   }
              // }
              axios
                .get(process.env.API_LOCATION + '/api/dpr/inactiveOperator', {
                  headers: {
                    'x-auth-token': sessionStorage.token
                  },
                  params: {
                    id: this.selectedUser.id
                  }
                })
                .then(response => {
                  const content = response.data
                  if (content.errors) {
                    console.log('inactiveOperator API Call Error: ' + content.errors)
                  }
                  this.$parent.$parent.$refs.AdminConsoleRef.loadAdminConsole()
                })

              this.$bvToast.toast('User successfully deactivated.', {
                title: 'User Status Updated',
                toaster: 'b-toaster-top-center'
              })
              this.$bvModal.hide('confirmInactiveModal')
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    deleteGroup(row) {
      if (confirm('Confirm you want to delete group ' + row.group + '.')) {
        if (sessionStorage.token) {
          axios
            .get(process.env.API_LOCATION + '/api/users/deleteGroup/', {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                group_name: row.group
              }
            })
            .then(response => {
              const content = response.data
              if (content.errors) {
                console.log('deleteGroup API Call Error: ' + content.errors)
                // Else no errors and we can load returned entry into form
              } else {
                for (let i = this.groupsRows.length - 1; i >= 0; i--) {
                  if (i + 1 === row.vbt_id) {
                    this.groupsRows.splice(i, 1)
                  }
                }
                this.deletedGroupFeedback =
                  `'` + row.group + `' group has been deleted.`
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          console.log('No User Token')
        }
      }
    },
    initNewUserModal() {
      this.closeUAC()
      this.$bvModal.show('NewUserModal')
    },
    loadAuthorizationCount() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/countAuthorizations', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Authorization Count API Call Error: ' + content.errors)
            } else {
              this.permissionsRows = content.rows
              this.loadRecentUsages()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    loadGroupCount() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/groups', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Groups API Call Error: ' + content.errors)
            } else {
              this.groups = content.rows
              axios
                .get(process.env.API_LOCATION + '/api/users/countGroups', {
                  headers: {
                    'x-auth-token': sessionStorage.token
                  }
                })
                .then(response => {
                  const content = response.data
                  if (content.errors) {
                    console.log('Groups Count API Call Error: ' + content.errors)
                  } else {
                    this.groupsRows = content.rows
                  }
                })
                .catch(function (error) {
                  console.log(error)
                })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    initNewGroupModal() {
      this.$bvModal.show('NewGroupModal')
    },
    updateGroup(props) {
      props.unmodifiedName = props.group
      props.update = true
    },
    changeGroupName(props) {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/updateGroup', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              old_name: props.unmodifiedName,
              new_name: props.group
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Update Group API call error: ' + content.errors)
            } else {
              this.updateGroupSuccess = 'Group updated to ' + props.group
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
      // Close text input box
      props.update = false
    },
    cancelChangeGroupName(props) {
      props.group = props.unmodifiedName
      props.update = false
    },
    updateGroupSuccessHide() {
      this.updateGroupSuccess = ''
    },
    changeTimePeriod(days) {
      this.recentPeriod = days
      switch (days) {
        case 1:
          this.currentTitle = this.titleDay
          this.dayButtonClassCtrl = 'primary'
          this.weekButtonClassCtrl =
            this.monthButtonClassCtrl =
            this.quarterButtonClassCtrl =
            this.halfYearButtonClassCtrl =
            this.yearButtonClassCtrl =
              'light'
          break
        case 7:
          this.currentTitle = this.titleWeek
          this.weekButtonClassCtrl = 'primary'
          this.dayButtonClassCtrl =
            this.monthButtonClassCtrl =
            this.quarterButtonClassCtrl =
            this.halfYearButtonClassCtrl =
            this.yearButtonClassCtrl =
              'light'
          break
        case 30:
          this.currentTitle = this.titleMonth
          this.monthButtonClassCtrl = 'primary'
          this.dayButtonClassCtrl =
            this.weekButtonClassCtrl =
            this.quarterButtonClassCtrl =
            this.halfYearButtonClassCtrl =
            this.yearButtonClassCtrl =
              'light'
          break
        case 90:
          this.currentTitle = this.titleThreeMonths
          this.quarterButtonClassCtrl = 'primary'
          this.dayButtonClassCtrl =
            this.weekButtonClassCtrl =
            this.monthButtonClassCtrl =
            this.halfYearButtonClassCtrl =
            this.yearButtonClassCtrl =
              'light'
          break
        case 180:
          this.currentTitle = this.titleSixMonths
          this.halfYearButtonClassCtrl = 'primary'
          this.dayButtonClassCtrl =
            this.weekButtonClassCtrl =
            this.monthButtonClassCtrl =
            this.quarterButtonClassCtrl =
            this.yearButtonClassCtrl =
              'light'
          break
        case 365:
          this.currentTitle = this.titleYear
          this.yearButtonClassCtrl = 'primary'
          this.dayButtonClassCtrl =
            this.weekButtonClassCtrl =
            this.monthButtonClassCtrl =
            this.quarterButtonClassCtrl =
            this.halfYearButtonClassCtrl =
              'light'
          break
      }
    },
    loadRecentUsages() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/countUsages', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              period: this.recentPeriod
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('countUsages API Call Error: ' + content.errors)
            } else {
              let authLabels = []
              let data = []
              let newPermissionsRows = []
              for (let i in this.permissionsRows) {
                let currentRow = this.permissionsRows[i]
                let currentPerm = currentRow['permissions']
                for (let j in content.rows) {
                  if (currentPerm === content.rows[j]['permissions']) {
                    currentRow['users'] = content.rows[j]['users']
                  }
                }
                if (!currentRow['users']) {
                  currentRow['users'] = '0'
                }
                newPermissionsRows.push(currentRow)
              }
              this.permissionsRows = newPermissionsRows
              this.permissionsRows.forEach(row => {
                authLabels.push(row.permissions)
                data.push(parseInt(row.users))
              })
              ApexCharts.exec('loginsByPermissionLevel', 'updateOptions', { labels: authLabels })
              ApexCharts.exec('loginsByPermissionLevel', 'updateSeries', data)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    loadTestAccountsRows() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/testAccountsList', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Test Accounts List API Call Error: ' + content.errors)
            } else {
              this.testAccountsRows = content.rows
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    // resetUACforAcquisitionAdmin() {
    //   if (this.user.role == 'USHR Acquisition Admin') {
    //     //this.clearForm() // REFACTOR WEBGIS-2618 -- clearForm() is not a fn
    //     //this.generatePassword() // REFACTOR WEBGIS-2618 -- generatePassword() is not a fn
    //     this.permissions = []
    //     this.permissions = [
    //       {perm: {permissions: 'USHR Operator'}, name: 'USHR Operator'}
    //     ]
    //   }
    // },
    csvExport(parsedJson, filename) {
      if (
        !Array.isArray(parsedJson) ||
        !parsedJson.every(p => typeof p === 'object' && p !== null)
      ) {
        return
      }
      const heading = Object.keys(parsedJson[0]).join(',') + '\n'
      const body = parsedJson.map(j => Object.values(j).join(',')).join('\n')
      this.csv = 'data:text/csv;charset=utf-8,'
      this.csv += `${heading}${body}`
      const data = encodeURI(this.csv)
      const link = document.createElement('a')
      link.setAttribute('href', data)
      link.setAttribute('download', `${filename}.csv`)
      link.click()
    },
    rebuildActions() {
      this.actions = [
        {
          btn_text: 'Inactive Users',
          event_name: 'flipInactive',
          class: this.inactiveClass
        },
        {
          btn_text: 'Inactive Users Report',
          event_name: 'downloadCSV',
          event_payload: {
            msg: 'Download CSV'
          },
          class: 'btn btn-success mr-5'
        },
        {
          btn_text: 'Add New User',
          event_name: 'newUser',
          event_payload: {
            msg: 'Add new entry'
          },
          class: 'btn btn-success mr-5'
        }
      ]
    }
  },
  mounted() {
    this.rebuildActions()
    this.getCompanies()
  },
  computed: {
    ...mapGetters(['globalUserRole', 'globalAllowedUserModules', 'globalIsUserAllowed']),
    filteredUsers() {
      return this.usersRows.filter(user => {
        // Status filtering (your existing logic)
        if (!this.statuses.length) return false;
        const isActive = user.inactive === null;
        const isInactive = !isActive;

        const matchesStatus =
          (this.statuses.includes(true) && isActive) ||
          (this.statuses.includes(false) && isInactive);

        // Date filtering using sortable_date (which should be "YYYY-MM-DD")
        const userDate = user.sortable_date; // string like "2025-07-25"

        // If fromdate or todate are empty, ignore that boundary
        const from = this.fromdate || null; 
        const to = this.todate || null;

        let matchesDate = true;

        if (from && to) {
          matchesDate = userDate >= from && userDate <= to;
        } else if (from) {
          matchesDate = userDate >= from;
        } else if (to) {
          matchesDate = userDate <= to;
        }

        return matchesStatus && matchesDate;
      });
    }
  },
  watch: {
    inactiveClass: function (newValue, oldValue) {
      this.rebuildActions()
    },
    recentPeriod: function (newValue, oldValue) {
      this.loadRecentUsages()
    },
    newGroupAdded: {
      deep: true,
      handler: function (newValue, oldValue) {
        if (newValue.groupAdded) {
          this.loadGroupCount()
          this.addedGroupFeedback = 'New group has been added.'
        } else if (!newValue.feedbackHidden) {
          this.deletedGroupFeedback = 'Group with that name already exists.'
        }
      }
    }
  }
}
</script>
